export const SNAPSHOT_COOLDOWN_MS = 60 * 60 * 1000;

export function getLatestSnapshotAt(snapshots = []) {
  let latest = null;
  snapshots.forEach((s) => {
    if (!s?.created_at) return;
    const t = new Date(s.created_at);
    if (Number.isNaN(t.getTime())) return;
    if (!latest || t > latest) latest = t;
  });
  return latest;
}

export function formatSnapshotTime(value) {
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: d.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatRelative(value, now = Date.now()) {
  const d = value instanceof Date ? value : new Date(value);
  const diff = Math.max(0, now - d.getTime());
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ${mins % 60}m ago`;
  const days = Math.floor(hours / 24);
  return `${days} day${days !== 1 ? "s" : ""} ago`;
}

export function formatCountdown(ms) {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
